import { Endpoint } from '@/types/api.type.ts';

export const auctionEndpoints: Endpoint[] = [
    {
        name: 'GetLastAuctionByCarsIds',
        method: 'get',
        path: '/auctions/last-auction-by-car-id',
    },
    {
        name: 'GetAuctionSaleContractFile',
        method: 'get',
        path: '/auctions/sale-contracts/:id/file',
    },
    {
        name: 'GetAuctionInvoiceFile',
        method: 'get',
        path: '/auctions/invoices/:id/file',
    },
    {
        name: 'GetAuctions',
        method: 'get',
        path: '/auctions',
    },
    {
        name: 'ForceCompleteAuction',
        method: 'patch',
        path: '/auctions/force-complete/:id',
    },
    {
        name: 'ProlongAuction',
        method: 'patch',
        path: '/auctions/prolong/:id',
    },
    {
        name: 'CreateAuction',
        method: 'post',
        path: '/auctions/',
    },
    {
        name: 'PublishLot',
        method: 'patch',
        path: '/auctions/:id/publish',
    },
    {
        name: 'GetAuction',
        method: 'get',
        path: '/auctions/:id',
    },
    {
        name: 'UpdateAuction',
        method: 'post',
        path: '/auctions/:id',
    },
    {
        name: 'PublishAuction',
        method: 'patch',
        path: '/auctions/:id/publish',
    },
    {
        name: 'DeleteAuction',
        method: 'delete',
        path: '/auctions/:id',
    },
    {
        name: 'SendAnnouncementAboutAuction',
        method: 'get',
        path: '/auctions/:id/send-announcement',
    },
     {
        name: 'AnnulAuction',
        method: 'post',
        path: '/auctions/:id/annul',
    },
    {
        name: 'CreateAuctionBid',
        method: 'post',
        path: '/auctions/:id/bids',
    },
    {
        name: 'GetAuctionBids',
        method: 'get',
        path: '/auctions/:id/bids',
    },
    {
        name: 'ConfirmAuctionWinner',
        method: 'patch',
        path: '/auctions/confirm-winner/:id',
    },
    {
        name: 'SetAuctionDeliveryRequired',
        method: 'patch',
        path: '/auctions/set-delivery-required/:id',
    },
    {
        name: 'GetJoiningAuctions',
        method: 'get',
        path: '/auctions/bids',
    },
    {
        name: 'GetAuctionCountByCarIdOnCurrentMonth',
        method: 'get',
        path: '/auctions/auctions-count-by-car-on-current-month',
    },
];
